import React from 'react';

import { FlattenedProductProps } from '../../../models';
import { useVirtualizer } from '@tanstack/react-virtual';
import ProductListItem from '../../../components/sales-terminal/products/product-list/list/list-item';
import { VirtualizedGridContainer } from '../../resuable-ui/VirtualizedGridContainer/VirtualizedGridContainer';
import GridSettings from './grid.settings';

const { gap, overscan, gridBreakpoints, estimatedItemHeight } = GridSettings.LIST;

export const VirtualizeList = ({
	products,
	parentRef,
}: {
	products: FlattenedProductProps[] | null;
	parentRef: React.RefObject<HTMLDivElement>;
}) => {
	return (
		<VirtualizedGridContainer
			gap={gap}
			overscan={overscan}
			estimatedItemHeight={estimatedItemHeight}
			gridBreakpoints={gridBreakpoints}
		>
			{products?.map((product) => <ProductListItem key={product._id} product={product} />) as React.ReactNode[]}
		</VirtualizedGridContainer>
	);
};

export default React.memo(VirtualizeList);
